// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"3c4917b6","488":"0dfdc195"}[chunkId] + ".chunk.js";
};